import React, { Component } from 'react';
import Login from './Login.js';
import Profile from './Profile.js';
import Signup from './Signup.js';
import axios from 'axios';
import lang_en from '../images/lang_en.png';
import lang_es from '../images/lang_es.png';
import { ERRORS, LANG } from '../App.js';
import { Redirect } from 'react-router-dom';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import HomeScreenFireFox from '../images/firefox.png';
import HomeScreenFireFox2 from '../images/firefox2.png';
import HomeScreenSafari from '../images/safari.png';
import HomeScreenIphone1 from '../images/iphone1.jpg';
import HomeScreenIphone2 from '../images/iphone2.jpg';
import Header from '../components/Header/index.jsx';
export const GENDER = {
  FEMALE: 2,
  MALE: 1,
  OTHER: 3
};

export const SECTION = {
  LOGIN: 1,
  SIGNUP: 2,
  PROFILE: 3
};

const EXTERNAL_LOGIN = {
  GOOGLE: "Google",
  FACEBOOK: "Facebook"
};

let cancelToken;

class OnboardingContainer extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();
    const routerState = props.location.state;
    if (routerState) this.state.section = routerState.section;
    //this.loadGapiAndAfterwardsInitAuth();


    function GDeferred() {
      var self = this;
      this.promise = new Promise(function (resolve, reject) {
        self.reject = reject
        self.resolve = resolve
      });
    }

    window.googleLoaded = (new GDeferred());
  }

  loadGapiAndAfterwardsInitAuth = () => {
    const script = document.createElement("script");
    script.src = "https://apis.google.com/js/platform.js";
    script.async = true;
    script.defer = true;
    script.onload = this.initAuth;
    const meta = document.createElement("meta");
    meta.name = "google-signin-client_id";
    meta.content = process.env.REACT_APP_GOOGLE_SIGNUP_KEY;
    document.head.appendChild(meta);
    document.head.appendChild(script);
  }

  initAuth = () => {
    window.gapi.load('auth2', function () {
      window.gapi.auth2.init();
      window.googleLoaded.resolve();

    });
  }



  loadGoogle = (type) => {
    let thiss = this;
    window.gapi.load('auth2', function () {
      // Retrieve the singleton for the GoogleAuth library and set up the client.
      var auth2 = window.gapi.auth2.init({
        client_id: process.env.REACT_APP_GOOGLE_SIGNUP_KEY,
        cookiepolicy: 'single_host_origin',
        // Request scopes in addition to 'profile' and 'email'
        //scope: 'additional_scope'
      });
      thiss.setState({ auth2: auth2 }, () => { thiss.attachSignin(document.getElementById('gSignInWrapper'), type) });
    });
  }

  attachSignin = (element, type) => {
    console.log("sign in att", type);
    let getGData = this.getGoogleData;
    this.state.auth2.attachClickHandler(element, {},
      function (googleUser) {
        getGData(googleUser, type);
      }, function (error) {
        console.log(error, undefined, 2);
      });
  }

  getGoogleData = (googleUser, type) => {
    console.log("metodo google");
    var profile = googleUser.getBasicProfile();
    var name = profile.getName().split(" ");
    this.setState({ email: profile.getEmail(), name: name[0], lastname: name[1] });
    console.log("getgoogle data", type);
    if (type === "SIGNUP") {
      this.sendExternalLoginData(profile.getEmail(), EXTERNAL_LOGIN.GOOGLE);
    } else {
      this.login({
        email: profile.getEmail(),
        external_login: EXTERNAL_LOGIN.GOOGLE,
        token_id: this.props.getTokenId()
      });
    }

  }

  clickCreactCuenta = (e) => {
    e.preventDefault();
    let getFacebook = this.getFacebookData;
    window.FB.login(function (response) {
      if (response.status === 'connected') {
        getFacebook("SIGNUP");
      } else {
        console.log(' X NO conectado,crear cuenta?');
      }
    }, { scope: 'email' });

  }

  loginWithFacebook = (e) => {
    e.preventDefault();
    let getFacebook = this.getFacebookData;
    window.FB.login(function (response) {
      if (response.status === 'connected') {
        getFacebook("LOGIN");
      } else {
        console.log('Couldnt connect to facebook');
      }
    });

  }

  getFacebookData = (type) => {
    let thiss = this;
    window.FB.api('/me', { fields: 'name,email' }, function (response) {
      //console.log('datos del api',response);
      var name = response.name.split(" ");
      thiss.setState({ email: response.email, name: name[0], lastname: name[1] });

      ////
      if (type === "SIGNUP") {
        thiss.sendExternalLoginData(response.email, EXTERNAL_LOGIN.FACEBOOK);
      } else {
        thiss.login({
          email: response.email,
          external_login: EXTERNAL_LOGIN.FACEBOOK,
          token_id: thiss.props.getTokenId()
        });
      }
    });
  }


  sendExternalLoginData = (email, source) => {
    const { t } = this.props;
    this.props.post(
      "/signup",
      { token_id: this.props.getTokenId(), 'email': email, 'password': null, 'external_login': source },
      (response) => this.externalSignup(source),
      (error) => {
        if (error === ERRORS.INPUT) {
          this.setState({ error: t('onboarding.signup.error_credentials') });
        } else {
          this.props.handleErrorResponse(error)
        }
      },
      cancelToken
    );
  }


  externalSignup = (source) => {
    window.ga('send', 'event', 'Signup', 'create');
    const loginInfo = {
      'email': this.state.email,
      'external_login': source,
      'token_id': this.props.getTokenId()
    };

    this.props.post(
      "/login",
      loginInfo,
      (response) => this.didLoginFirstTime(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );


  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  didEditProfile = () => {
    this.setState({ toDashboard: true });
  }

  didLogin = (response) => {
    this.props.setUser(response);
    // if (response.name == null || response.lastname == null) {
    //   this.setState({
    //     section: SECTION.PROFILE,
    //     isLoading: false
    //   });
    // } else {
    this.setState({
      toDashboard: true,
      isLoading: false
    });
    // }
  }

  didLoginFirstTime = (response) => {
    this.props.setUser(response);
    this.setState({
      section: SECTION.PROFILE,
      isLoading: false
    });
  }

  didResetPassword = () => {
    const { t } = this.props;
    this.setState({ success: t('onboarding.login.password_reset') });
  }

  didSignup = () => {
    this.loginFirstTime({
      email: this.state.email,
      password: this.state.password,
      token_id: this.props.getTokenId()
    });
  }

  editProfile = (params) => {
    this.props.post(
      "/editProfile",
      params,
      (response) => this.didEditProfile(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getInitState = () => {
    return {
      birthDay: "",
      birthMonth: "",
      birthYear: "",
      email: "",
      error: "",
      gender: null,
      lastname: "",
      name: "",
      password: "",
      passwordConfirm: "",
      phone: "",
      section: SECTION.LOGIN,
      success: "",
      toDashboard: false,
      fName: "",
      fEmail: "",
      fBirthday: "",
      auth2: null,
      isLoading: false
    };
  }

  handleBirthDay = (event) => {
    this.setState({ birthDay: event.target.value });
  }

  handleBirthMonth = (event) => {
    this.setState({ birthMonth: event.target.value });
  }

  handleBirthYear = (event) => {
    this.setState({ birthYear: event.target.value });
  }

  handleClearError = () => {
    this.setState({ error: "" });
  }

  handleClearSuccess = () => {
    this.setState({ success: "" });
  }

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  }

  handleGenderChange = (event) => {
    this.setState({ gender: Number(event.target.value) });
  }

  handleLastnameChange = (event) => {
    this.setState({ lastname: event.target.value });
  }

  handleLoginClick = () => {
    this.handleClearError();
    this.setState({ section: SECTION.LOGIN });
  }

  handleLoginSubmit = (event) => {
    event.preventDefault();
    this.handleClearError();
    this.setState({ isLoading: true });
    this.login({
      email: this.state.email,
      password: this.state.password,
      token_id: this.props.getTokenId()
    });
  }

  handleNameChange = (event) => {
    this.setState({ name: event.target.value });
  }

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  }

  handlePasswordConfirm = (event) => {
    this.setState({ passwordConfirm: event.target.value });
  }

  handlePasswordReset = () => {
    this.resetPassword({
      email: this.state.email,
      token_id: this.props.getTokenId()
    });
  }

  handlePhoneChange = (event) => {
    this.setState({ phone: event.target.value });
  }

  handleProfileSubmit = (event) => {
    event.preventDefault();

    const birthdate = this.state.birthYear + "-"
      + this.state.birthMonth + "-"
      + this.state.birthDay;

    this.props.setUser(Object.assign(
      {},
      this.props.user,
      { lastname: this.state.lastname },
      { name: this.state.name }
    ));

    this.editProfile({
      birthdate: birthdate,
      gender: this.state.gender,
      lastname: this.state.lastname,
      name: this.state.name,
      phone: this.state.phone,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  handleSignupClick = () => {
    this.handleClearError();
    this.setState({ section: SECTION.SIGNUP });
  }

  handleSignupSubmit = (event) => {
    event.preventDefault();
    this.handleClearError();
    this.setState({ isLoading: true });
    const { t } = this.props;

    if (this.state.password !== this.state.passwordConfirm) {
      this.setState({ error: t('onboarding.signup.error_password') });
      return;
    }

    const uppercaseRegExp = /(?=.*?[A-Z])/;
    const lowercaseRegExp = /(?=.*?[a-z])/;
    const digitsRegExp = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*?[#?!@$%^&*-.'"])/;
    const minLengthRegExp = /.{8,}/;

    const passwordLength = this.state.password.length;
    const uppercasePassword = uppercaseRegExp.test(this.state.password);
    const lowercasePassword = lowercaseRegExp.test(this.state.password);
    const digitsPassword = digitsRegExp.test(this.state.password);
    const specialCharPassword = specialCharRegExp.test(this.state.password);
    const minLengthPassword = minLengthRegExp.test(this.state.password);

    if (passwordLength === 0) {
      alert("La contraseña está vacía");
      return;
    } else if (!uppercasePassword) {
      alert("La contraseña debe tenerl al menos una mayúsculas");
      return;
    } else if (!lowercasePassword) {
      alert("La contraseña debe tenerl al menos una minúsculas");
      return;
    } else if (!digitsPassword) {
      alert("La contraseña debe tenerl al menos un numero ");
      return;
    } else if (!specialCharPassword) {
      alert("La contraseña debe tenerl al menos un caracter especial");
      return;
    } else if (!minLengthPassword) {
      alert("La contraseña debe tenerl al menos 8 un caracteres");
      return;
    }

    this.signup({
      email: this.state.email,
      password: this.state.password,
      token_id: this.props.getTokenId()
    });
  }

  login = (params) => {
    const { t } = this.props;
    this.props.post(
      "/login",
      params,
      (response) => this.didLogin(response),
      (error) => {
        if (error === ERRORS.INPUT) {
          this.setState({
            error: t('onboarding.login.error_credentials')
          });
        } else {
          this.props.handleErrorResponse(error)
        }
        this.setState({ isLoading: false });
      },
      cancelToken
    );
  }

  loginFirstTime = (params) => {
    this.props.post(
      "/login",
      params,
      (response) => this.didLoginFirstTime(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  resetPassword = (params) => {
    const { t } = this.props;
    this.props.post(
      "/recoveryPassword",
      params,
      (response) => this.didResetPassword(response),
      (error) => {
        if (error === ERRORS.INPUT) {
          this.setState({ error: t('onboarding.login.error_pwdreset') });
        } else {
          this.props.handleErrorResponse(error)
        }
      },
      cancelToken
    );
  }

  signup = (params) => {
    const { t } = this.props;
    this.props.post(
      "/signup",
      params,
      (response) => this.didSignup(response),
      (error) => {
        if (error === ERRORS.INPUT) {
          this.setState({ error: t('onboarding.signup.error_credentials') });
        } else {
          this.props.handleErrorResponse(error)
        }
        this.setState({ isLoading: false });
      },
      cancelToken
    );
  }

  renderLogin = () => {
    return (
      <Login
        email={this.state.email}
        error={this.state.error}
        handleClearError={this.handleClearError}
        handleClearSuccess={this.handleClearSuccess}
        handleEmailChange={this.handleEmailChange}
        handleLoginSubmit={this.handleLoginSubmit}
        handlePasswordChange={this.handlePasswordChange}
        handlePasswordReset={this.handlePasswordReset}
        handleSignupClick={this.handleSignupClick}
        handleLanguageChange={this.props.handleLanguageChange}
        password={this.state.password}
        success={this.state.success}
        isLoading={this.state.isLoading}
        loadGoogle={this.loadGoogle}
        loginWithFacebook={this.loginWithFacebook} />
    );
  }

  renderProfile = () => {
    return (
      <Profile
        birthDay={this.state.birthDay}
        birthMonth={this.state.birthMonth}
        birthYear={this.state.birthYear}
        error={this.state.error}
        gender={this.state.gender}
        handleClearError={this.handleClearError}
        handleClearSuccess={this.handleClearSuccess}
        handleBirthDay={this.handleBirthDay}
        handleBirthMonth={this.handleBirthMonth}
        handleBirthYear={this.handleBirthYear}
        handleGenderChange={this.handleGenderChange}
        handleLastnameChange={this.handleLastnameChange}
        handleNameChange={this.handleNameChange}
        handlePhoneChange={this.handlePhoneChange}
        handleProfileSubmit={this.handleProfileSubmit}
        lastname={this.state.lastname}
        name={this.state.name}
        phone={this.state.phone}
        success={this.state.success} />
    );
  }

  renderSection = () => {
    switch (this.state.section) {
      default:
      case SECTION.LOGIN:
        return this.renderLogin();
      case SECTION.PROFILE:
        return this.renderProfile();
      case SECTION.SIGNUP:
        return this.renderSignup();
    }
  }

  renderSignup = () => {
    return (
      <Signup
        email={this.state.email}
        error={this.state.error}
        handleClearError={this.handleClearError}
        handleClearSuccess={this.handleClearSuccess}
        handleEmailChange={this.handleEmailChange}
        handleLoginClick={this.handleLoginClick}
        handlePasswordChange={this.handlePasswordChange}
        handlePasswordConfirm={this.handlePasswordConfirm}
        handleSignupSubmit={this.handleSignupSubmit}
        password={this.state.password}
        passwordConfirm={this.state.passwordConfirm}
        success={this.state.success}
        isLoading={this.state.isLoading}
        loadGoogle={this.loadGoogle}
        clickCreactCuenta={this.clickCreactCuenta} />
    );
  }

  render() {
    if (this.state.toDashboard) {
      return <Redirect to="/marketplace" />;
    }
    const { t } = this.props;

    const userAgent = window.navigator.userAgent;
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
    const isIphone = /iPhone/.test(userAgent);
    const isApple = /iPad|iPhone|iPod/.test(userAgent) || isSafari;

    return (
      <div className="login-container">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-xl-offset-3">
                <div className="change-lenguage">
                  {/* <a onClick={this.props.handleLanguageChange}>
                    <img
                      alt={t('onboarding.img_lang')}
                      src={this.props.lang === LANG.EN ? lang_es : lang_en}
                      style={{ float: "right", marginRight: "5px" }}
                      width="20px" />
                  </a> */}
                  {this.renderSection()}
                </div>
              </div>
              {/*<div className="booking">
                <h4>{t('onboarding.booking.title')}</h4>
                <br />
                <a href="https://iosferaweb.iosoffices.com/store" rel="noopener noreferrer" target="_blank">
                  <button className="btn btn-block btn-default">
                    {t('onboarding.booking.btn_book')}
                    <i className="glyphicon glyphicon-arrow-right" style={{marginLeft: "10px"}} />
                  </button>
                </a>
                <p>{t('onboarding.booking.subtitle')}</p>
              </div>*/}
            </div>
          </div>
        </div>
        <div className="modal fade bs-example-modal-lg-singup" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {t('onboarding.login.other')}
                </h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {isApple ? t('onboarding.login.safari1') : t('onboarding.login.firefox1')}
                <div className="modal-body">
                  <img alt={t('onboarding.login.firefox')} src={
                    isSafari
                      ? HomeScreenSafari
                      : (isIphone ? HomeScreenIphone1 : HomeScreenFireFox)
                  } style={{ width: "100%" }} />
                </div>
                {isApple ? t('onboarding.login.safari2') : t('onboarding.login.firefox2')}
                {
                  !isSafari && (
                    <div className="modal-body">
                      <img alt={t('onboarding.login.firefox')} src={
                        isIphone
                          ? HomeScreenIphone2
                          : HomeScreenFireFox2
                      } style={{ width: "100%" }} />&nbsp;
                    </div>
                  )
                }
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                  {t('dashboard.room_payment.btn_modal_exit')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(OnboardingContainer);



// WEBPACK FOOTER //
// ./src/onboarding/OnboardingContainer.js